import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import PillsMenu from '@app/components/parents/PillsMenu'
import Retriever from '@app/containers/parents/Children/Retriever'
import StudentsTable from '@app/components/parents/Children/StudentsTable'
import { Can } from '@app/context/ability-context'
import ParticipationInstructionsButton from '@app/components/shared/ParticipationInstructionsButton'
import ParentParticipationInstructions from '@app/components/shared/instructions/ParentParticipationInstructions'

import SVG from "react-inlinesvg"
import statisticsIcon from '@icons/statistics/primary'
import helpIcon from '@icons/help/primary'

import _ from 'lodash'

const Content = ({ students, ...rest }) => {
  const objects = _.values(students.objects);

  const handleInstructionsCallback = (name, e) => {
    if (name === 'add-students') {
      const button = document.getElementById('addStudentsButton');
      if (button) { button.click(); }
    }

    return true;
  }

  return (
    <Fragment>
      <div className="plate-headbar">
        <h1 className="plate-heading plate-heading--left">
          { I18n.t('parent_students.index.your_students') }
        </h1>
        <div className="grid grid--sm-1 grid--sm-1--ng grid--md-2 grid--md-2--inline grid--xl-2 grid--xl-2--inline">
          <Can I="read" a="StatisticsPage">
            <div className="mt-0">
              <Link to="/parents/statistics"
                    className="link link--icon-left f--upper"
                    disabled={objects.length === 0}>

                <SVG src={statisticsIcon} />
                { I18n.t('teachers.show.statistic') }
              </Link>
            </div>
          </Can>

          <div className="mt-0">
            <ParticipationInstructionsButton
              callback={handleInstructionsCallback}
              Component={ParentParticipationInstructions}
              students={objects}
            />
          </div>
        </div>
      </div>

      <div className="plate plate--xl mt-0">
        <StudentsTable
          {...rest}
          students={objects}
          config={{ mode: "parent", deleteEnabled: true }}
        />
      </div>
    </Fragment>
  )
}

const Children = ({ route, parent }) => {
  return (
    <Fragment>
      <div className="page">
        <Retriever ChildComponent={Content} />
      </div>
    </Fragment>
  )
}

Children.propTypes = {
  route: PropTypes.object.isRequired
}

export default Children
